import React from 'react'
import { func, string, object } from 'prop-types'
import { withContext } from '../../../utils/withContext'
import styles from './PaymentTypeInput.styl'
import FaCheckmark from 'react-icons/lib/fa/check'

class PaymentTypeInput extends React.Component {

	static propTypes = {
		onChange: func,
		value: string,
		context: object
	}

	handleChange(e) {
		const { onChange } = this.props
		onChange(e.target.dataset.value)
	}

	render() {
		const { value, context: { i18n } } = this.props
		return (
			<div
				className={ styles['container'] }
				onChange={ this.handleChange.bind(this) }
			>
				<div
					data-value="semester"
					className={ value === 'semester' ? styles['active'] : '' }
					onClick={ this.handleChange.bind(this) }
				>
					{ i18n`full_payment_label` }
					<div className={ styles['checkmark'] }>
						<FaCheckmark />
					</div>
				</div>
				<div
					data-value="monthly"
					className={ value === 'monthly' ? styles['active'] : '' }
					onClick={ this.handleChange.bind(this) }
				>
					{ i18n`monthly_payment_label` }
					<div className={ styles['checkmark'] }>
						<FaCheckmark />
					</div>
				</div>
			</div>
		)
	}
}

export default withContext(PaymentTypeInput)



// WEBPACK FOOTER //
// ./src/client/webapp/components/PaymentTypeInput/PaymentTypeInput.js